import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import EElement from '~/features/ui/models'

const useGetElementDimensions = (elementId: EElement) => {
  const [width, setWidth] = useState<number>(0)
  const [height, setHeight] = useState<number>(0)
  const location = useLocation()

  // initial dimensions
  useEffect(() => {
    if (!width && !height) {
      const headerElement = document.getElementById(elementId)
      if (!headerElement) return
      setWidth(headerElement.clientWidth)
      setHeight(headerElement.clientHeight)
    }
  }, [width, height, elementId])

  // resize event listener
  useEffect(() => {
    const headerElement = document.getElementById(elementId)

    function handleResize() {
      if (!headerElement) return
      setWidth(headerElement.clientWidth)
      setHeight(headerElement.clientHeight)
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [elementId])

  // react-router-dom location change
  useEffect(() => {
    const headerElement = document.getElementById(elementId)
    if (!headerElement) return
    setWidth(headerElement.clientWidth)
    setHeight(headerElement.clientHeight)
  }, [location, elementId])

  return { width, height }
}

export default useGetElementDimensions
